import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static values = { url: String }

  connect() {
    this.keydown = this.keydown.bind(this)
    window.addEventListener("keydown", this.keydown)
  }

  disconnect() {
    window.removeEventListener("keydown", this.keydown)
  }

  keydown(event) {
    if (!(event.key.toLowerCase() === "k" && (event.metaKey || event.ctrlKey))) return

    event.preventDefault()
    const quickSearch = document.querySelector("[data-controller~='quick-search']")

    if (quickSearch?.offsetParent) {
      quickSearch.dispatchEvent(new CustomEvent("quick-search:open"))
      return
    }

    const input = document.querySelector("main [data-search-input]")

    if (input) {
      input.focus()
      input.select()
    } else {
      Turbo.visit(this.urlValue)
    }
  }
}
